import { FC } from 'react';
import { useScreenType } from '@web3/base-hooks';
import { openLink } from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import styles from './index.module.scss';
import { Event, Page } from '@/config/track-config';

interface IProps {
  dappId?: number;
  name: string;
  logo: string;
  website: string;
  description: string;
}

export const DAppCard: FC<IProps> = ({ name, logo, website, description }) => {
  const { isMobile } = useScreenType();

  return (
    <div
      onClick={() => {
        scTrack(Event.Web3UserClick, {
          page_name: Page.Home,
          area: 'ExploreDApps',
          button_name: 'dApps',
          params: website,
        });
        if (isMobile) {
          openLink(website);
          return;
        }
        window.open(website, '_blank');
      }}
      className={styles.dappCard}
    >
      <div className={styles.dappCard_left}>
        <img src={logo} alt="img" />
      </div>
      <div className={styles.dappCard_right}>
        <div className={styles.dappCard_right__title}>{name}</div>
        <div className={styles.dappCard_right__desc}>{description}</div>
      </div>
    </div>
  );
};
